import React from 'react';
import Header from '../componentes/Header';
import productosPertina from '../data/todosLosProductos/productosPertina';
import { NavLink, Link, useNavigate } from 'react-router';
import AnimacionPagina from '../componentes/AnimacionPagina';
import { motion } from 'framer-motion';

import SectionProductos from '../elementos/SectionProductos';
import ContainerProductos from '../elementos/ContaninerProductos';
import ProductoContainer from '../elementos/ProductoContainer';
import BtnVolverAnim from '../elementos/BtnVolverAnim';
import { Helmet } from 'react-helmet';
import Footer from '../componentes/Footer';

const PaginaPertinas = () => {
        const navigate = useNavigate();
    return ( 
        <>
        <Helmet>
            <title>Pertina | Hi Blinds</title>
            <meta name="description" content="Pertinas elegantes con tejidos como Rocks, Dimmer e Infinity. Calidad textil con más de 50 años de experiencia." />
            <meta property="og:title" content="Pertina | Hi Blinds" />
            <meta property="og:description" content="Explora nuestras pertinas con tejidos exclusivos como Dimmer e Infinity. Diseño y funcionalidad en un solo producto." />
            <meta property="og:url" content="https://hiblindsmx.com/pertina" />
        </Helmet>

            <Header />
            <AnimacionPagina>
                <SectionProductos>

                <h1>Pertina</h1>
                <BtnVolverAnim Ref='/'/>
                <ContainerProductos>
                    {productosPertina.map((producto, index) =>  {
                     const { imagenDemostracion } = procesarProducto(producto);

                     return (
                        <motion.div
                        key={producto.id}
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.4, delay: index * 0.1 }}
                        >
                            <ProductoContainer 
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.8 }}
                            key={producto.id}
                            onClick={() => {
                            navigate(`/pertina/${producto.slug}`);
                                }}
                            style={{ cursor: 'pointer' }}>
                                <img 
                                loading='lazy' 
                                src={imagenDemostracion} 
                                alt={`${producto.nombre}`} 
                                />
                                <h4>{producto.nombre}</h4>
                                <p>Ancho de tela: {producto.anchoTela}</p>
                                <Link to={`/pertina/${producto.slug}`}>
                                <button type='button'>Más información</button>
                               </Link>
                            </ProductoContainer>
                        </motion.div>
                     );
                 })}
                </ContainerProductos>
                {/* <div>
                    <h2>Componentes</h2>
                    <p>Color</p>
                </div> */}
                <BtnVolverAnim Ref='/'/>
                </SectionProductos>
                <Footer />
            </AnimacionPagina>
            
        </>
     );
}
const procesarProducto = (producto) => {
    const imagenDemostracion = producto.images[0];
    const imagenesColores = producto.images.slice(1).map((imagen, index) => ({
        color: producto.colores[index],
        imagen
    }));
    return { imagenDemostracion, imagenesColores };
};




export default PaginaPertinas;